var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.shouldShowSinglePlan
        ? [
            _c("div", { staticClass: "row wrapper" }, [
              _c(
                "h4",
                { staticClass: "col xs-12 margin-top payment-plan-title" },
                [_vm._v(_vm._s(_vm.paymentPlanTitle))]
              ),
            ]),
            _vm._v(" "),
            _vm.missingPaymentTypeError
              ? _c(
                  "div",
                  { staticClass: "row wrapper selected-payment-type-error" },
                  [
                    _c("p", { staticClass: "col xs-12 dark-blue-text" }, [
                      _vm._v(_vm._s(_vm.missingPaymentTypeError)),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        : [
            _c("div", [
              _c("div", { staticClass: "wrapper" }, [
                !_vm.baselinePhoenixChanges
                  ? _c(
                      "h3",
                      {
                        staticClass: "col xs-12 margin-top payment-plan-title",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.checkoutContent.selectAPaymentPlan)
                        ),
                      ]
                    )
                  : _c(
                      "h3",
                      {
                        staticClass: "col xs-12 margin-top payment-plan-title",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.renewalsPersistedVariables.jsonContent.text
                                .confirmPaymentPlan
                            )
                        ),
                      ]
                    ),
              ]),
              _vm._v(" "),
              _vm.isPhoenixPhaseTwoCustomer
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "flex m-1 justify-center toggle-button" },
                      [
                        _c(
                          "button",
                          {
                            class:
                              _vm.renewalTerm === 36
                                ? "toggle-button-clicked"
                                : "toggle-button-left",
                            on: {
                              click: function ($event) {
                                return _vm.handleTermChange(36)
                              },
                            },
                          },
                          [_vm._v("36 Months Term")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            class:
                              _vm.renewalTerm === 12
                                ? "toggle-button-clicked"
                                : "toggle-button-right",
                            on: {
                              click: function ($event) {
                                return _vm.handleTermChange(12)
                              },
                            },
                          },
                          [_vm._v("12 Months Term")]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showContractDisclaimer
                ? _c(
                    "div",
                    {
                      staticClass: "col xs-12 bold",
                      attrs: { id: "terms-remaining" },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.checkoutContent.selectPaymentInfo
                              .terms_remaining
                          ) +
                          " " +
                          _vm._s(_vm.licenseTerm) +
                          "\n                "
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "mt-0 mb-2",
                          attrs: { id: "contract-disclaimer" },
                        },
                        [_vm._v(_vm._s(_vm.contractDisclaimer))]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row option-container" },
              _vm._l(_vm.approvedPaymentPlanOptions, function (plan) {
                return _c("PaymentPlanTile", {
                  key: plan,
                  attrs: {
                    id: _vm.paymentPlanOptions[plan].paymentHeader,
                    paymentPlan: plan,
                    paymentHeader: _vm.paymentHeader(plan),
                    paymentSubHeader: _vm.paymentSubHeader(),
                    monthlyCost: _vm.paymentPlanOptions[plan].monthlyCost,
                    monthlyListPriceCost: _vm.calculateMonthlyListPriceCost,
                    breakdown: _vm.paymentPlanOptions[plan].breakdown,
                    discount: _vm.paymentPlanOptions[plan].discount,
                    totalSavings: _vm.calculateTotalSavings(
                      plan,
                      _vm.approvedPaymentPlanOptions.length
                    ),
                  },
                  on: {
                    scrollToPricingBreakdown: () =>
                      _vm.$emit("scrollToPricingBreakdown"),
                  },
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.clickpathCotermingEnabled
              ? _c("div", [
                  _c("div", {
                    attrs: { id: "payment-notice" },
                    domProps: { innerHTML: _vm._s(_vm.renewalPaymentNotice()) },
                  }),
                ])
              : _vm.selectedPaymentType
              ? _c("div", { staticClass: "row" }, [
                  _c("p", { attrs: { id: "payment-notice" } }, [
                    _vm._v(_vm._s(_vm.paymentNotice)),
                  ]),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }